/* Lavender Farm Simulator — quiet writes (rebuild step 2).
   Many parts of the game re-write the same attribute, id or "inert" value onto the page several times a second.
   Each write, even with an unchanged value, wakes every page watcher, which then re-scans thousands of controls.
   Inside the simulator only, a write that would not change anything is now skipped. Nothing else changes.
   Covers setAttribute, id, className, inert, hidden, title, textContent and dataset, plus the farm clock box.
   Kill switch: localStorage.gllfQuietOff = "1" (then reload). */
(function () {
  'use strict';
  if (window.__gllfQuiet) return;
  try { if (localStorage.getItem('gllfQuietOff') === '1') return; } catch (e) {}
  window.__gllfQuiet = { skipped: 0 };
  var Q = window.__gllfQuiet, root = null;
  function inSim(el) {
    if (!root || !root.isConnected) root = document.getElementById('lfg-simulator-root');
    return !!root && (el === root || root.contains(el));
  }
  var SKIP = /^(src|srcset|href|value|checked|selected|style)$/i;
  var EP = Element.prototype, setA = EP.setAttribute;
  EP.setAttribute = function (name, value) {
    if (this.nodeType === 1 && !SKIP.test(name) && this.tagName.indexOf('-') < 0) {
      var cur = this.getAttribute(name);
      if (cur !== null && cur === String(value) && inSim(this)) { Q.skipped++; return; }
    }
    return setA.call(this, name, value);
  };
  function guardProp(proto, prop) {
    var d = Object.getOwnPropertyDescriptor(proto, prop);
    if (!d || !d.set || !d.get || !d.configurable) return;
    Object.defineProperty(proto, prop, {
      configurable: true, enumerable: d.enumerable, get: d.get,
      set: function (v) {
        var cur = d.get.call(this);
        var same = typeof cur === 'boolean' ? (typeof v === 'boolean' && cur === v) : cur === String(v);
        if (same && inSim(this)) { Q.skipped++; return; }
        d.set.call(this, v);
      }
    });
  }
  guardProp(EP, 'id');
  guardProp(EP, 'className');
  guardProp(HTMLElement.prototype, 'inert');
  guardProp(HTMLElement.prototype, 'hidden');
  guardProp(HTMLElement.prototype, 'title');
  /* text: skip only when the element already holds exactly that one piece of text */
  var td = Object.getOwnPropertyDescriptor(Node.prototype, 'textContent');
  if (td && td.set && td.configurable) Object.defineProperty(Node.prototype, 'textContent', {
    configurable: true, enumerable: td.enumerable, get: td.get,
    set: function (v) {
      if (this.nodeType === 1) {
        var f = this.firstChild, t = v == null ? '' : String(v);
        if (f && f === this.lastChild && f.nodeType === 3 && f.data === t && inSim(this)) { Q.skipped++; return; }
        /* the clock add-on owns the running/paused label; the game rewrites it every second with its own wording */
        if (this.hasAttribute('data-pulse-time-mode-label') && this.querySelector('.lfg-try-state') && inSim(this)) { Q.skipped++; return; }
      }
      td.set.call(this, v);
    }
  });
  /* data-* marks (el.dataset.x = ...): same rule */
  var dsCache = new WeakMap();
  function guardDataset(proto) {
    var d = proto && Object.getOwnPropertyDescriptor(proto, 'dataset');
    if (!d || !d.get || !d.configurable) return;
    Object.defineProperty(proto, 'dataset', {
      configurable: true, enumerable: d.enumerable,
      get: function () {
        var p = dsCache.get(this); if (p) return p;
        var el = this, real = d.get.call(this);
        p = new Proxy(real, { set: function (t, k, v) {
          if (typeof k === 'string' && t[k] === String(v) && inSim(el)) { Q.skipped++; return true; }
          t[k] = v; return true;
        } });
        dsCache.set(this, p); return p;
      }
    });
  }
  guardDataset(HTMLElement.prototype);
  guardDataset(window.SVGElement && SVGElement.prototype);
  /* The farm clock redraws its whole box every game minute (once a second in real-time mode). Other add-ons
     then re-label parts of it, and every watcher on the page reacts to the brand-new elements. When the new
     markup has the same shape, only the words and settings that changed in the game's own markup are updated. */
  var ih = Object.getOwnPropertyDescriptor(Element.prototype, 'innerHTML');
  function walk(n, fn) { for (var c = n.firstChild; c; c = c.nextSibling) { fn(c); if (c.nodeType === 1) walk(c, fn); } }
  function sig(n) { var s = []; walk(n, function (c) { s.push(c.nodeType === 1 ? c.tagName + ':' + c.childNodes.length : c.nodeType); }); return s.join(','); }
  function snap(n) {
    var s = []; walk(n, function (c) {
      if (c.nodeType === 1) { var a = {}; for (var i = 0; i < c.attributes.length; i++) a[c.attributes[i].name] = c.attributes[i].value; s.push(a); }
      else s.push(c.nodeType === 3 || c.nodeType === 8 ? c.data : null);
    }); return s;
  }
  function nodes(n) { var s = []; walk(n, function (c) { s.push(c); }); return s; }
  function morph(box, html) {
    if (!box.__gllfSnap || !box.firstChild) return false;
    var t = document.createElement('template'); ih.set.call(t, html);
    var tsig = sig(t.content); if (tsig !== box.__gllfSig || sig(box) !== tsig) return false;
    var now = snap(t.content), old = box.__gllfSnap, dom = nodes(box);
    for (var i = 0; i < dom.length; i++) {
      var d = dom[i], nv = now[i], ov = old[i];
      if (typeof nv === 'string') { if (nv !== ov && d.data !== nv) d.data = nv; }
      else if (nv && d.nodeType === 1) {
        for (var k in nv) if (nv[k] !== (ov && ov[k]) && d.getAttribute(k) !== nv[k]) setA.call(d, k, nv[k]);
        if (ov) for (var k2 in ov) if (!(k2 in nv)) d.removeAttribute(k2);
      }
    }
    box.__gllfSnap = now; Q.morphed = (Q.morphed || 0) + 1; return true;
  }
  if (ih && ih.set && ih.configurable) Object.defineProperty(Element.prototype, 'innerHTML', {
    configurable: true, enumerable: ih.enumerable, get: ih.get,
    set: function (v) {
      if (this.nodeType === 1 && this.hasAttribute('data-farm-clock')) {
        var html = v == null ? '' : String(v);
        try { if (morph(this, html)) return; } catch (e) {}
        ih.set.call(this, html);
        try { this.__gllfSig = sig(this); this.__gllfSnap = snap(this); } catch (e) { this.__gllfSnap = null; }
        return;
      }
      ih.set.call(this, v);
    }
  });
})();
